import { TThunkAction } from '../../types/redux';
import { getLocations } from '../../api/location';
import { getLocationsRequestError, getLocationsRequestStart, getLocationsRequestSuccess } from './actions';

export function getLocationsIfEmpty(): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const {
      geo: { locations, isFetching },
    } = getState();

    /** Не запрашиваем данные, если регионы уже загружены или в процессе загрузки **/
    if (locations || isFetching) {
      return;
    }

    try {
      dispatch(getLocationsRequestStart());

      const regions = await getLocations(context);

      dispatch(getLocationsRequestSuccess(regions));
    } catch {
      dispatch(getLocationsRequestError());
    }
  };
}
